import api from '@/api/index.js'

const emv_cut_overs = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_EMV_CUT_OVERS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_EMV_CUT_OVERS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EMV_CUT_OVERS_ERROR: (state, error) => {
      state.error = error
    },
    SET_EMV_CUT_OVERS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadEmvCutOvers({commit}, query) {
      commit('SET_EMV_CUT_OVERS', [])
      commit('SET_EMV_CUT_OVERS_ERROR', null)
      commit('SET_EMV_CUT_OVERS_LOADING', true)
      return api.get(`emv-cut-overs?limit=300&offset=0`)
        .then((response) => {
          commit('SET_EMV_CUT_OVERS', response)
        })
        .catch((error) => {
          commit('SET_EMV_CUT_OVERS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_CUT_OVERS_LOADING', false)
        })
    }
  }
}

export default emv_cut_overs
